import React from 'react';
import { Divider, Typography } from '@mui/material';
import mistiKumra from '../../../../../images/Agri-info/crops/misti_Kumra_মিষ্টি কুমড়া.jpg';
import useDocumentTitle from '../../../../../hooks/useDocumentTitle';

const MistiKumraInfo = () => {

    // dynamic title
    useDocumentTitle("মিষ্টি কুমড়া");

    return (

        <div className=" rounded-3 bg-white my-4 px-5">
            <Typography
                sx={{
                    textAlign: "center",
                    pb: 2,
                    pt: 3,
                    fontWeight: 600,
                    color: 'rgb(37, 36, 36, 0.83)'
                }}
                variant="h4"
                noWrap
                component="div"
            >
                মিষ্টি কুমড়া
            </Typography>
            <Divider />

            <div className="card mt-4 mb-3 border-0 rounded-0">
                <div className="row g-0">
                    <div className="col-md-4">
                        <img src={mistiKumra} className="img-fluid rounded-0 h-100" alt="..." />
                    </div>
                    <div className="col-md-8">
                        <div className="card-body text-start ">
                            <p className="card-text fw-bold">ভূমিকা</p>
                            <p className="card-text">মিষ্টি কুমড়া বর্ষজীবী লতানো উদ্ভিদ। মিষ্টি কুমড়ার শিকড় যথেষ্ট বিস্তৃত। কচি মিষ্টি কুমড়া সবজি হিসেবে এবং পাকা ফল দীর্ঘদিন রেখে সবজি হিসেবে ব্যবহার করা যায়। পরিপক্ক ফল শুষ্ক ঘরে সাধারণ তাপমাত্রায় প্রায় ৪-৬ মাস সংরক্ষণ করা যায়। মিষ্টি কুমড়া ডায়াবেটিস রোগ নিয়ন্ত্রনে কাজ করে</p>

                            <p className="card-text fw-bold">মাটির বৈশিষ্ট</p>
                            <p className="card-text">চরাঞ্চলের পলি মাটিতে মিষ্টি কুমড়া ভালো ফলন হয়। জৈব পদার্থ সমৃদ্ধ দোঁ-আশ বা এঁটেল দোঁ-আশ মাটি এর চাষাবাদের জন্য উত্তম। মিষ্টি কুমড়ার জন্য মাটির সর্বোত্তম অম্ল-ক্ষারত্ব ৫.৫-৬.৮।</p>

                        </div>
                    </div>
                </div>
            </div>

            <div className='text-start pb-5'>

                <p className="card-text fw-bold">চাষের মৌসুম</p>
                <p className="card-text">বাংলাদেশের আবহাওয়ায় বছরের যে কোনো সময় মিষ্টি কুমড়ার বীজ বোনা যায়। শীতকালীন ফসলের জন্য অক্টোবর থেকে ডিসেম্বর এবং গ্রীষ্মকালীন ফসলের জন্য ফেব্রুয়ারি থেকে মে মাস পর্যন্ত বীজ বোনার উপযুক্ত সময় তবে বীজ উৎপাদনের জন্য নভেম্বরের মধ্যভাগে বীজ বপন করা উত্তম।</p>

                <p className="card-text fw-bold">চারা উৎপাদন</p>
                <p className="card-text">
                    •     পলিব্যাগে চারা উৎপাদন<br />
                    •    পলিব্যাগে মিষ্টি কুমড়ার চারা উৎপাদনের ক্ষেত্রে ৩X৪ ইঞ্চি (৮X১০(সে.মি) আকারের পলিব্যাগ ব্যবহার করা হয়।<br />
                    •     অতিরিক্ত পানি নিষ্কাশনের জন্য ছিদ্রযুক্ত পলিব্যাগে ব্যবহার করতে হবে।</p>

                <p className="card-text fw-bold">পলিব্যাগে বীজ বপন</p>
                <p className="card-text">
                    •   প্রথমে অর্ধেক মাটি ও অর্ধেক গোবর মিশিয়ে মাটি তৈরি করে নিতে হবে। মাটিতে বীজ গজানোর জন্য “জো” নিশ্চিত করে (মাটিতে “জো” না থাকলে পানি দিয়ে “জো” করে নিতে হবে) তা পলিব্যাগে ভরতে হবে।<br />
                    •   অতঃপর প্রতি ব্যাগে দুইটি করে বীজ বুনতে হবে। বীজের আকারের দ্বিগুণ মাটির গভীরে বীজ পুঁতে দিতে হবে।</p>

                <p className="card-text fw-bold">বীজের পরিমাণ</p>
                <p className="card-text">মিষ্টি কুমড়া চাষের জন্য শতাংশ প্রতি ২.৫ গ্রাম পরিমাণ বীজের প্রয়োজন হয়।
                    সারের পরিমাণ ও প্রয়োগ পদ্ধতি (কেজি শতাংশ)</p>

                <p className="card-text fw-bold">প্রয়োগ পদ্ধতি</p>
                <p className="card-text">মূল জমি তৈরীর সময় জৈব সার, টিএসপি, দস্তা, ম্যাগনেসিয়াম ও বোরিক এসিডের অর্ধেক অংশ প্রয়োগ করতে হবে। বাকি অর্ধেক জৈব সার, টিএসপি, দস্তা, ম্যাগনেসিয়াম ও বোরিক এসিড মাদায় প্রয়োগ করতে হবে। ইউরিয়া ও এমওপি সমান তিনভাগে ভাগ করে বীজ বপনের সময় প্রথম ভাগ, ১৫-২০ দিন পর দ্বিতীয় ভাগ এবং ৩৫-৪০ দিন পর তৃতীয়ভাগ প্রয়োগ করতে হবে।</p>

                <p className="card-text fw-bold">চারা রোপন</p>
                <p className="card-text">
                    •   চারা বয়সঃ বীজ গজানোর পর ১৫-১৬ দিন বয়সের চারা মাঠে লাগানোর জন্য উত্তম।<br />
                    •    পলিব্যাগের ভাঁজ বরাবর ব্লেড দিয়ে কেটে পলিব্যাগ সরিয়ে মাটির দলাসহ চারাটি নির্দিষ্ট জায়গায় লাগিয়ে চারপাশে মাটি দিয়ে ভরাট করে দিতে হবে। চারা লাগানোর পর গর্তে পানি দিতে হবে।</p>

                <p className="card-text fw-bold">জাতসমূহ</p>
                <p className="card-text">লাল তীর সীড লিমিটেড উদ্ভাবিত ও বাজারজাতকৃত জাতসমূহ নিম্নরূপ</p>

                <p className="card-text fw-bold">সুপ্রিমা</p>
                <p className="card-text">সুপ্রিমা একটি হাইব্রিড জাত। এটি চ্যাপ্টা, গোলাকার ও অগভীর দাঁড়া উঠানো ফল। মাংসল অংশ বেশ পুরু ও গাঢ় হলুদ। ফলের গড় ওজন ৪-৫ কেজি। কাঁচা ও পাকা দুই ভাবেই খাওয়া যায়।<br />
                    রোপনের সময়ঃ আগস্ট-ফেব্র্বয়ারি<br />
                    ফসল তোলার মেয়াদঃ ৭৫-৮০ দিন।</p>

                <p className="card-text fw-bold">সুইটি</p>
                <p className="card-text">দিবস নিরপেক্ষ হাইব্রিড জাত। সারা বছর চাষযোগ্য। ফল চ্যাপ্টা এবং ভিতরের মাংসল অংশ বেশ পুরু ও গাঢ় হলুদ। প্রতিটি ফলের গড় ওজন ৭-৮ কেজি। কাঁচা ও পাকা দুই ভাবেই খাওয়া যায়।<br /><br />রোপনের সময়ঃ ১২ মাস।<br />ফসল তোলার মেয়াদঃ ৭৫-৮০ দিন।<br />ফলনঃ ১৮-২০</p>

                <p className="card-text fw-bold">ড্রিমগোল্ড</p>
                <p className="card-text">দিবস নিরপেৰ হাইব্রিড জাত। সারা বছর চাষযোগ্য। মাংসল অংশ বেশ পুরু এবং ফলের গড় ওজন ৫-৬ কেজি। কাঁচা ও পাকা দুই ভাবেই খাওয়া যায়।</p>
                <p className="card-text">রোপনের সময়ঃ ১২ মাস।<br />ফসল তোলার মেয়াদঃ ৭৫-৮০ দিন।<br />ফলন (টন/একর) ১৮-২০</p>

                <p className="card-text fw-bold">সলিড গোল্ড</p>
                <p className="card-text">দিবস নিরপেক্ষ হাইব্রিড জাত। বহিঃত্বক হালকা খাজযুক্ত। মাংসল অংশ পুরু এবং গাঢ় হলুদ বর্ণের। ফল ডোমাকৃতির এবং গড় ওজন ৫-৬ কেজি। রাজশাহী অঞ্চলের জন্য খুবই উপযোগী।</p>
                <p className="card-text">রোপনের সময়ঃ ১২ মাস।<br />ফসল তোলার মেয়াদঃ ৭৫-৮০ দিন।<br />ফলন (টন/একর) ১৮-২০</p>

                <p className="card-text fw-bold">পোকামাকড় ও দমন ব্যবস্থাপনা</p>
                <p className="card-text fw-bold">মিষ্টি কুমড়ার মাছিপোকা</p>
                <p className="card-text">ক্ষতির ধরণ-
                    ১. এই পোকা মিষ্টি কুমড়ার কচিফল ও ফুলের মধ্যে প্রথমে ডিম পাড়ে।<br />
                    ২. পরবর্তীতে ডিম থেকে কীড়া বের হয়ে ফল ও ফুলের ভিতর কুরে কুরে খায় যার ফলে ফল ও ফুল পচন ধরে নষ্ট হয়ে যায়।<br />
                    ৩. এই পোকার আক্রমণের ফলে প্রায় ৫০-৭০ ভাগ ফল নষ্ট হয়ে যায়। </p>

                <p className="card-text fw-bold">দমন ব্যবস্থাপনা</p>
                <p className="card-text">
                    ১.আক্রান্ত ফল সংগ্রহ করে তা নষ্ট করে ফেলতে হবে।<br />
                    ২. পরিষ্কার পরিচ্ছন্ন চাষাবাদ।<br />
                    ৩. সেক্স ফেরোমন ফাঁদের ব্যবহার<br />
                    ৪. মাছির আক্রমণ থেকে ফসল রৰা করার জন্য বিষটোপ অত্যন্ত কার্যকর।</p>

                <p className="card-text fw-bold">রেড পামকিন বিটল</p>
                <p className="card-text fw-bold">ক্ষতির ধরণ </p>
                <p className="card-text">
                    ১. পামকিন বিটলের পূর্ণবয়স্কপোকা চারা গাছের পাতায় ফুটো করে এবং পাতার কিনারা থেকে খাওয়া শুরু করে সম্পূর্ণ পাতা খেয়ে ফেলে।<br />
                    ২. এ পোকা ফুল ও কচি ফলেও আক্রমণ করে।</p>

                <p className="card-text fw-bold">দমন ব্যবস্থাপনা</p>
                <p className="card-text">
                    ১. চারা আক্রান্ত হলে হাত দিয়ে পূর্ণবয়স্ক পোকা ধরে মেরে ফেলে।<br />
                    ২. ক্ষেত সব সময় পরিষ্কার রাখা।</p>

                <p className="card-text fw-bold">জাবপোকা</p>
                <p className="card-text fw-bold">ক্ষতির ধরণ</p>
                <p className="card-text">
                    ১. জাবপোকার আক্রমণে মিষ্টি কুমড়ার বাড়ন্ত ডগা ও পাতা হলুদ হয়ে যায়। গাছ তার সতেজতা হারিয়ে ফেলে এবং ফলন গুরুতর ভাবে ক্ষতিগ্রস্ত হয়।    <br />
                    ২. প্রাপ্ত ও অপ্রাপ্তবয়স্ক জাবপোকা দলবদ্ধভাবে গাছের পাতার রস চুষে খায়। ফলে পাতা বিকৃত হয়ে যায়, বৃদ্ধি ব্যাহত হয় ও প্রায়শ নিচের দিকে কোঁকড়ানো দেখা যায়।<br />
                    ৩. মেঘলা, কুয়াশাচ্ছন্ন এবং ঠান্ডা আবহাওয়ায় জাবপোকার বংশ বৃদ্ধি বেশি হয়। প্রচুর পরিমাণে বৃষ্টি হলে এদের সংখ্যা কমে যায়। </p>

                <p className="card-text fw-bold">দমন ব্যবস্থাপনা</p>
                <p className="card-text">
                    ১. প্রাথমিক অবস্থায় আক্রান্ত পাতা ও ডগার জাবপোকা হাত দিয়ে পিষে মেরে ফেলা যায়। <br />
                    ২. নিমবীজের দ্রবণ বা সাবানগোলা পানি সেপ্র করেও এ পোকার আক্রমণ অনেকাংশে কমে যায়।<br />
                    ৩. বন্ধু পোকাসমূহ সংরক্ষণ করলে এ পোকার আক্রমণ অনেকাংশে কম হয়।</p>

                <p className="card-text fw-bold">রোগবালাই ও প্রতিকার</p>
                <p className="card-text fw-bold">সাদা গুঁড়া রোগ বা পাউডারি মিলডিউ</p>
                <p className="card-text fw-bold">ক্ষতির লক্ষণ</p>
                <p className="card-text">
                    ১. রোগের প্রারম্ভে গাছের নিচের বয়স্ক পাতায় রোগের লৰণ প্রকাশ পায়। ক্রমশ উপরের পাতায় রোগ ছড়িয়ে পড়ে।<br />
                    ২. প্রথমে পাতার উপর বিক্ষিপ্ত সাদা সাদা দাগের সৃষ্টি হয়।<br />
                    ৩. রোগ বিস্তারের সঙ্গে সঙ্গে দাগ আকারে বড় হতে থাকে এবং হলুদ বর্ণ থেকে বাদামী রঙ ধারণ করে।<br />
                    ৪. রোগের প্রকোপ বেশি হলে গাছের লতা ও কান্ড আক্রান্ত হয়। ধীরে ধীরে সেই লতা ও পরে পুরো গাছই মরে যেতে পারে।</p>

                <p className="card-text fw-bold">দমন ব্যবস্থাপনা</p>
                <p className="card-text">
                    ১. রোগ নিয়ন্ত্রণের জন্য লাউ ও কুমড়াজাতীয় আগাছা বিনাশ করতে হবে।<br />
                    ২. জমির আশে-পাশে কুমড়া জাতীয় যে কোন সবজি চাষ থেকে বিরত থাকা<br />
                    ৩. আগাম চাষ করে রোগের প্রকোপ কমানো যায়।<br />
                    ৪. প্রতি ১০ লিটার পানিতে ২০ গ্রাম ইনসাফ/থিয়ভিট বা সালফোলাঙ/কুমুলাস অথবা ১০ গ্রাম ক্যালিঙিন ১৫ দিন পর পর সেপ্র করে এ রোগ নিয়ন্ত্রণ করা।</p>

                <p className="card-text fw-bold">ডাউনি মিলডিউ</p>
                <p className="card-text fw-bold">ক্ষতির লক্ষণ</p>
                <p className="card-text">
                    ১. এই রোগ শুধু পাতায় হয়। আক্রান্ত পাতায় নানা আকারের দাগ পড়ে। সাধারণত দাগগুলি কোণাকৃতি ও হলদে হয়।<br />
                    ২. দাগগুলি খুব তাড়াতাড়ি সংখ্যায় বৃদ্ধি পায় ও আকারে বড়ো হয়। পাতার নিচে দিকে দাগের উপরে বেগুনি রংয়ের ছত্রাক জন্মে। </p>

                <p className="card-text fw-bold">দমন ব্যবস্থাপনা</p>
                <p className="card-text">
                    ১. রোগ নিয়ন্ত্রণের জন্য লাউ ও কুমড়াজাতীয় আগাছা বিনাশ করতে হবে।<br />
                    ২. জমির আশেপাশে কুমড়া জাতীয় যে কোনো সবজি চাষ থেকে বিরত থাকা।<br />
                    ৩. আগাম চাষ করে রোগের প্রকোপ কমানো যায়।</p>


            </div>
        </div >

    );
};

export default MistiKumraInfo;